import React from 'react';
import './CaseSingle.css';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const CaseSingle = () => { 

  // Get case study details passed via router state
  const location = useLocation();  
  const caseSingle = location.state; 

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={'Case Single'} page={'Case Single'} />

      <section className='case-single page-single'>

        <div className='case-info page-info'>

          {/* Case Study Image Section */}
          <div className='image'>
            <img src={caseSingle.image} alt={caseSingle.title} />
          </div>

          <div className='content'>

            {/* Case Study Title */}
            <h3 className='main-heading'>{caseSingle.title}</h3>

            {/* Case Study Description */}
            {caseSingle.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Case Study Image Gallery */}
            <Lightbox images={caseSingle.gallery} />

            {/* Case Study Challenges Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Challenges Faced:</h3>

              {/* Introduction to challenges */}
              <p>{caseSingle.challenges.intro}</p>
              
              {/* List of Case Study Challenges */}
              <ul>
                {caseSingle.challenges.points.map((challenge, index) => {
                  return <li key={index}><FaCheck className='icon' />{challenge}</li>
                })}
              </ul>

            </div>

            {/* Case Study Solutions Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Solutions Provided:</h3>

              {/* Introduction to solutions */}
              <p>{caseSingle.solutions.intro}</p>

              {/* List of solutions */}
              <ul>
                {caseSingle.solutions.points.map((solution, index) => {
                  return <li key={index}><FaCaretRight className='icon' />{solution}</li>
                })}
              </ul>

            </div>

            {/* Case Study Results Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Results & Impact:</h3>

              {/* Introduction to results */}
              <p>{caseSingle.results.intro}</p>
              
              {/* List of achieved results */}
              <ul>
                {caseSingle.results.points.map((result, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{result}</li>
                })}
              </ul>

            </div>

          </div> 
        
        </div> 

        {/* Sidebar with Case Study details */}
        <PageSidebar
          heading={'Case Study'}
          details={caseSingle.details}
        />

      </section>

    </> 
  );
}

export default CaseSingle ;